<chart-details-layout
  [chartDetails]="chartDetails"
  [isLoading]="isLoading"
  [showFormButtons]="showFormButtons"
  (save)="onSaveSettings()"
  (cancel)="onRevertSettings()"
>
  <top-search-terms-chart chart [showTitle]="false"></top-search-terms-chart>
  <base-details
    detailsComponent
    *ngIf="!isLoading"
    [chartDetails]="chartDetails"
    [generalSettings]="config?.generalSettings"
    (generalSettingsChange)="onGeneralSettingsChange($event)"
  >
    <div #filterContent>
      <div class="row">
        <div class="col-lg-12">
          <div class="form-group input-group has-feedback" style="position: relative;">
            <label class="control-group input-group-addon" for="selectedMin"
              >Min Used
                <button class="info-btn"
                        type="button"
                        [attr.title]="info('minUsed')"
                        (click)="onInfoClick($event, 'minUsed')">
                    i
                </button>
              </label
            >
            <input
              id="selectedMin"
              name="selectedMin"
              type="number"
              [(ngModel)]="selectedMinUsed"
              class="form-control"
              (click)="hideTooltip()"
            />

            <div class="click-tooltip"
                 *ngIf="isTooltipVisible('minUsed')"
                 (click)="hideTooltip()">
              {{ info('minUsed') }}
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="row">
        <div class="col-lg-12">
          <div class="form-group input-group has-feedback">
            <label class="control-group input-group-addon" for="numResults"
              >Top</label
            >
            <input
              id="numResults"
              name="numResults"
              type="number"
              [(ngModel)]="selectedNumberResults"
              class="form-control"
            />
          </div>
        </div>
      </div> -->
      <!-- Deprecated: fields to select columns in sub tables -->
      <!-- <div class="row">
        <div class="col-lg-12">
          <div class="form-group input-group has-feedback">
            <label
              class="control-group input-group-addon"
              style="
                vertical-align: top;
                white-space: break-spaces;
                text-align: left;
                line-height: 1.5em;
              "
              title="Choose details to display"
              >Document Details</label
            >
            <div class="form-control" style="height: unset">
              <ng-container
                *ngIf="
                  config?.generalSettings?.legendLabels.includes('Documents');
                  else noOptions1
                "
              >
                <div
                  *ngFor="let option of chartDetails.customLabels['Documents']"
                  class="form-check"
                >
                  <input
                    type="checkbox"
                    class="form-check-input"
                    [id]="option"
                    [value]="option"
                    [checked]="
                      config?.customLabelSelection &&
                      config.customLabelSelection['Documents'].includes(option)
                    "
                    (change)="toggleCustomLabelOption(option, 'Documents')"
                  />
                  <label [for]="option" class="form-check-label">{{
                    option
                  }}</label>
                </div>
              </ng-container>
              <ng-template #noOptions1>
                <p>
                  Choose the option 'Documents' below to see individual details
                  available.
                </p>
              </ng-template>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </base-details>
</chart-details-layout>
